import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const STAGE_KEYS = [
  'heimdal_app.TOTP.stage_configure',
  'heimdal_app.TOTP.stage_verify',
  'heimdal_app.TOTP.stage_finish',
];

const DOT_BASE = {
  width: '8px',
  height: '8px',
  borderRadius: '9999px',
  flexShrink: 0,
};

const DOT = {
  active: {
    ...DOT_BASE,
    background: 'var(--zippedi-accent)',
    boxShadow: '0 0 8px var(--zippedi-accent-glow)',
  },
  done: {
    ...DOT_BASE,
    background: 'var(--zippedi-success)',
    boxShadow: '0 0 8px var(--zippedi-success-glow)',
  },
  pending: {
    ...DOT_BASE,
    background: 'currentColor',
  },
};

const LABEL_BASE = { fontSize: '13px', lineHeight: 1.2 };

const LABEL = {
  active: {
    ...LABEL_BASE,
    fontWeight: 700,
    color: 'var(--zippedi-text-on-dark-primary)',
  },
  done: {
    ...LABEL_BASE,
    fontWeight: 600,
    color: 'var(--zippedi-text-on-dark-secondary)',
  },
  pending: {
    ...LABEL_BASE,
    fontWeight: 500,
  },
};

const LIST = {
  display: 'flex',
  flexDirection: 'column',
  gap: '26px',
  marginTop: '52px',
};

const ITEM_BASE = { display: 'flex', alignItems: 'center', gap: '14px' };

// The pending row sets the color its dot and its label both take.
const ITEM = {
  active: ITEM_BASE,
  done: ITEM_BASE,
  pending: { ...ITEM_BASE, color: 'var(--zippedi-text-on-dark-muted)' },
};

export default function LoginStepper({ activeStage }) {
  const { t } = useTranslation();

  return (
    <div role="list" style={LIST}>
      {STAGE_KEYS.map((key, index) => {
        const state =
          index < activeStage
            ? 'done'
            : index === activeStage
            ? 'active'
            : 'pending';
        return (
          <div
            key={key}
            role="listitem"
            aria-current={state === 'active' ? 'step' : undefined}
            style={ITEM[state]}>
            <div style={DOT[state]} />
            <span style={LABEL[state]}>{t(key)}</span>
          </div>
        );
      })}
    </div>
  );
}

LoginStepper.propTypes = {
  activeStage: PropTypes.number.isRequired,
};
